<ng-container *ngIf="errorMessage$ | async as errorMsg; else resultTemplate">
  <em-error-result [subTitle]="errorMsg"></em-error-result>
</ng-container>

<ng-template #resultTemplate>
  <nz-table
    #mtsTable
    [nzData]="(mtsData$ | async) ?? []"
    [nzLoading]="(loading$ | async) ?? false"
    nzSize="small"
  >
    <thead>
      <tr>
        <th>Equipment</th>
        <th>Lbnr</th>
        <th>Status</th>
        <th>Plant</th>
        <th>Location</th>
        <th>Rack</th>
        <th>Machine</th>
        <th>Row place</th>
        <th>Weight</th>
        <th>No. of inserts</th>
        <th>Mould type</th>
        <th>Box concept</th>
        <th>Cleaning week</th>
        <th>SYS cleaning pct</th>
        <th>SPPH</th>
      </tr>
    </thead>

    <tbody>
      <ng-container *ngFor="let mts of mtsTable.data; trackBy: trackByRef">
        <tr>
          <td>{{ mts.equipment.equipmentNumber | slice: 0 : -3 }}</td>
          <td>{{ mts.equipment.equipmentNumber | slice: -3 }}</td>
          <td>{{ mts.equipment.statusCode }}</td>
          <td>{{ mts.equipment.plannerGroupText }}</td>
          <td>{{ mts.equipment.locationtext }}</td>
          <td>{{ mts.equipment.settlementOrder }}</td>
          <td>{{ mts.construction.machineTypeDescription }}</td>
          <td>{{ mts.equipment.room }}</td>
          <td>
            {{ mts.formattedWeight | slice: 0 : -4 }}
            {{ mts.equipment.unitOfWeight }}
          </td>
          <td>{{ mts.equipment.actualNumberOfElements }}</td>
          <td>{{ mts.construction.mouldTypeDescription }}</td>
          <td>{{ mts.construction.boxConceptDescription }}</td>
          <td>{{ mts.equipment.cleaningWeek }}</td>
          <td>{{ mts.equipment.sysCleaningPct }}</td>
          <td>{{ mts.equipment.SPPH }}</td>
        </tr>
      </ng-container>
    </tbody>
  </nz-table>
</ng-template>
